import apiFetch from '../apiFetch'

export default function (userId, token) {
  return apiFetch({ endPoint: 'user/' + userId, method: 'GET', body: null, token: token })
}
